import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Circle } from '@alfa-bank/newclick-composite-components/icon-view/circle';
import { PureCell } from '@alfalab/core-components/pure-cell';
import { Typography } from '@alfalab/core-components/typography';
import { Underlay } from '@alfalab/core-components/underlay';
import { TelegramMIcon } from '@alfalab/icons-logotype/TelegramMIcon';
import { VkMIcon } from '@alfalab/icons-logotype/VkMIcon';
import { useWebview } from '../../../hooks/use-webview';
import { useWidgetContext } from '../../../hooks/use-widget-context';
import styles from './index.module.css';
const socialNetworkInfo = [
    {
        title: 'Группа в VK',
        link: 'https://vk.com/alfabank',
        Icon: VkMIcon,
        metric: 'OTHER_CONTACTS_VK',
        className: 'pureCell',
        id: 1,
        testId: 'other-contacts-vk',
    },
    {
        title: 'Канал в Telegram',
        link: 'https://t.me/AlfaBank',
        Icon: TelegramMIcon,
        metric: 'OTHER_CONTACTS_TELEGRAM',
        id: 2,
        testId: 'other-contacts-telegram',
    },
];
export const SocialNetworkInfo = () => {
    const { trackInAnalytics, platform } = useWidgetContext();
    const { bridgeToNative } = useWebview();
    const handleClick = (metric) => () => {
        trackInAnalytics(metric);
    };
    return (_jsx(Underlay, { backgroundColor: 'specialbg-secondary-transparent', borderRadius: 'l', padding: platform === 'mobile' ? 'm' : 'l', contentProps: {
            axis: 'vertical',
        }, children: socialNetworkInfo.map((item) => (_jsxs(PureCell, { className: item.className && styles[item.className], direction: 'horizontal', onClick: handleClick(item.metric), dataTestId: item.testId, href: item.link, target: '_blank', rel: 'noopener noreferrer', ...bridgeToNative?.nativeFallbacks.getExternalLinkProps(item.link), children: [_jsx(PureCell.Addon, { verticalAlign: 'center', addonPadding: 'none', children: _jsx(Circle, { size: 24, border: false, backgroundIcon: item.Icon, backgroundColor: 'transparent', className: styles.icon }) }), _jsx(PureCell.Content, { children: _jsx(PureCell.Main, { children: _jsx(Typography.Text, { view: 'component', children: item.title }) }) })] }, item.id))) }));
};
